'use client'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { useGTMUserIdentity } from '@b-stock/fe-core/bstock-next/hooks'
import type { GTMUserProperties } from '@b-stock/fe-core/bstock-next/hooks'

import { GTM_PLATFORM } from './constants'

/**
 * Pushes user identity data to the GTM dataLayer as a `user_data_ready` event.
 * This enables GTM to trigger a tag that sets 1st-party cookies with user
 * identity on the root domain, persisting identity for pages that can't push
 * auth info (e.g., Magento cross-domain).
 *
 * Must be rendered inside AuthProvider (both App Router and Pages Router
 * satisfy this requirement).
 */
export default function GTMIdentity() {
  const decodedToken = useDecodedAccessToken()

  const properties: GTMUserProperties = {
    platform: GTM_PLATFORM,
    user_id: decodedToken?.ua_id,
    person_id: decodedToken?.personId,
    account_id: decodedToken?.accountId,
    user_status: decodedToken ? 'logged_in' : 'guest',
    customer_type: decodedToken ? 'buyer' : 'guest',
  }

  useGTMUserIdentity('user_data_ready', properties)

  return null
}
